import parse, { Element, domToReact } from 'html-react-parser';
import React from 'react';
import { Link } from 'react-router-dom';
const options = {
    replace: (domNode) => {
        if (domNode instanceof Element && domNode.name === 'a' && domNode.attribs?.href) {
            const { href } = domNode.attribs;
            const getPathFromUrl = (url) => {
                try {
                    const urlObj = new URL(url);
                    return urlObj.pathname + urlObj.search + urlObj.hash;
                }
                catch {
                    return url;
                }
            };
            const path = getPathFromUrl(href);
            return React.createElement(Link, { to: path }, domToReact(domNode.children, options));
        }
    },
};
export const HtmlWithLinks = ({ html }) => {
    return parse(html, options);
};
